import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import ContributorsDetails from "modules/forecast-contributors"
import "./style.scss"

export default function AnalyzeForecastDetails({
  selectedDate,
  selected,
  selectedValue,
  viewType,
  order,
  hide,
  sort,
  openFactorProfile,
  openSecurityProfile,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  forecastId,
  details,
  show,
  groupOrder,

}) {
  return <div className={classnames("modules_analyze-forecast-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    <ContributorsDetails {...{
      viewType,
      openSecurityProfile,
      openFactorProfile,
      showGroup,
      hideGroup,
      selectedGroup,
      hide,
      sort,
      order,
      selected,
      selectedValue,
      selectedDate,
      setContributorsGrouping,
      contributorsGrouping,
      selectedOption,
      forecastId,
      details,
      show,
      groupOrder,
    }}
    />
  </div>
}

AnalyzeForecastDetails.propTypes = {
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  displayType: PropTypes.string,
  order: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  sort: PropTypes.func,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  forecastId: PropTypes.string,
  displayTypeName: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
}
